<style scoped>
.v-application .error {
    margin-left: 15px;
    margin-right: 15px;
    background-color: #78496a !important;
    border-color: black!important;
}
</style>
<template>
  <v-container class="py-5">
    <v-card>
      <v-card-title>
        Search
        <v-spacer></v-spacer>
       
      </v-card-title>
      <v-card-title>
        <slot></slot>
      </v-card-title>
      <v-card-subtitle
        v-if="error_message"
        class="white--text error"
      >{{ error_message }}</v-card-subtitle>
      <v-card-text>
        <v-container>
        </v-container>
        <v-data-table
          style="cursor: pointer"
          :headers="headers"
          :items="results"
          item-key="id"
          :options.sync="options"
         
          :footer-props="{ 'items-per-page-options': [5,10,20,50] }"
          :loading="loading"
          class="elevation-1"
        ></v-data-table>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
export default {
  name: "fhir-event-audit",
  data: function() {
    return {
      debug: "",
      headers: [
          { text: 'ID', value: 'id' },
          { text: 'Action', value: 'action' },
          { text: 'Agent', value: 'agent' },
          { text: 'Outcome', value: 'outcome' },
          { text: 'Recorded', value: 'recorded' },
      ],
      results: [],
      options: { itemsPerPage: 10,sortBy:['name'] },
      loading: false,
      total: 0,
      prevPage: -1,
      link: [],
      error_message: null,
      update_again: { rerun: false, restart: false }
    };
  },
  watch: {
    terms: {
      handler() {
        this.getData();
      },
      deep: true
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true
    }
  },
  created: function() {
     
  },
  methods:{
    getData() {
      let url = "/fhir/AuditEvent"
     /* if ( this.loading ) {
        this.update_again.rerun = true
        this.update_again.restart = this.update_again.restart || restart
        return
      }
      this.error_message = null;
      let url = "";
      if (restart) this.options.page = 1;
      if (this.options.page > 1) {
        if (this.options.page === this.prevPage - 1) {
          url = this.link.find(link => link.relation === "previous").url;
        } else if (this.options.page === this.prevPage + 1) {
          url = this.link.find(link => link.relation === "next").url;
        }
       
      */
      

      fetch(
        url
      )
        .then((response) => {
          response
            .json()
            .then((data) => {
              data.entry.forEach(adt => {
                let obj = adt.resource
                this.results.push({ 
                  id: obj.id,
                  action: obj.action,
                  agent: obj.agent[0].requestor,
                  outcome: obj.outcome,
                  recorded: obj.recorded,
                })
              });
              
            })
            .catch((err) => {
              console.log("ERROR ",err);
            });
        })
        .catch((err) => {
          console.log("ERROR 2", err);
        });
    }
  }
};
</script>
